import { jsx as _jsx } from "react/jsx-runtime";
import { faAngleDown, faAngleUp, faArrowLeft, faArrowRight, faChartMixed, faCheck, faClipboardList, faClone, faClose, faComment, faEllipsisH, faEllipsisV, faExclamationTriangle, faFilePdf, faFileSignature, faFlag, faInfoCircle, faList, faPenRuler, faPencilAlt, faPlus, faSearch, faShieldCheck, faSpinner, faTable, faTrashAlt, faUndo, faPenToSquare, } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
export const PentairIcon = styled(FontAwesomeIcon)(({ theme, fontSize, size }) => {
    switch (size) {
        case 'xs':
            fontSize = '0.875rem'; // 14px
            break;
        case 'sm':
            fontSize = '1rem'; // 16px
            break;
        case 'lg':
            fontSize = '1.25rem'; // 20px
            break;
        case 'xl':
            fontSize = '1.5rem'; // 24px
            break;
        default:
            fontSize = fontSize ?? '1.25rem'; // 20px
            break;
    }
    return {
        color: 'inherit',
        fontSize,
    };
});
PentairIcon.defaultProps = {
    fixedWidth: true,
};
export const PentairIconDelete = (props) => _jsx(PentairIcon, { ...props, icon: faTrashAlt });
export const PentairIconEdit = (props) => _jsx(PentairIcon, { ...props, icon: faPencilAlt });
export const PentairIconInfo = (props) => _jsx(PentairIcon, { ...props, icon: faInfoCircle });
export const PentairIconAlert = (props) => _jsx(PentairIcon, { ...props, icon: faExclamationTriangle });
export const PentairIconPdf = (props) => _jsx(PentairIcon, { ...props, icon: faFilePdf });
export const PentairIconCreate = (props) => _jsx(PentairIcon, { ...props, icon: faPlus });
export const PentairIconSpinner = (props) => _jsx(PentairIcon, { ...props, icon: faSpinner, spin: true });
export const PentairIconConfirm = (props) => _jsx(PentairIcon, { ...props, icon: faCheck });
export const PentairIconPrevious = (props) => _jsx(PentairIcon, { ...props, icon: faArrowLeft });
export const PentairIconNext = (props) => _jsx(PentairIcon, { ...props, icon: faArrowRight });
export const PentairIconClone = (props) => _jsx(PentairIcon, { ...props, icon: faClone });
export const PentairIconReset = (props) => _jsx(PentairIcon, { ...props, icon: faUndo });
export const PentairIconClose = (props) => _jsx(PentairIcon, { ...props, icon: faClose });
export const PentairIconChartMixed = (props) => _jsx(PentairIcon, { ...props, icon: faChartMixed });
export const PentairIconList = (props) => _jsx(PentairIcon, { ...props, icon: faList });
export const PentairSearchIcon = (props) => _jsx(PentairIcon, { ...props, icon: faSearch });
export const PentairIconAngleDown = (props) => _jsx(PentairIcon, { ...props, icon: faAngleDown });
export const PentairIconAngleUp = (props) => _jsx(PentairIcon, { ...props, icon: faAngleUp });
export const PentairIconPlus = (props) => _jsx(PentairIcon, { ...props, icon: faPlus });
export const PentairIconFlag = (props) => _jsx(PentairIcon, { ...props, icon: faFlag });
export const PentairIconClipboardList = (props) => _jsx(PentairIcon, { ...props, icon: faClipboardList });
export const PentairTableIcon = (props) => _jsx(PentairIcon, { ...props, icon: faTable });
export const PentairIconComment = (props) => _jsx(PentairIcon, { ...props, icon: faComment });
export const PentairElipsisVIcon = (props) => _jsx(PentairIcon, { ...props, icon: faEllipsisV });
export const PentairElipsisHIcon = (props) => _jsx(PentairIcon, { ...props, icon: faEllipsisH });
export const PentairPenRulerIcon = (props) => _jsx(PentairIcon, { ...props, icon: faPenRuler });
export const PentairFileSignatureIcon = (props) => _jsx(PentairIcon, { ...props, icon: faFileSignature });
export const PentairIconShieldCheck = (props) => _jsx(PentairIcon, { ...props, icon: faShieldCheck });
export const PentairIconPenToSquare = (props) => _jsx(PentairIcon, { ...props, icon: faPenToSquare });
